<template>
  <b-card
    no-body
    class="card-revenue-budget h-100"
    v-if="data"
  >
    <BRow class="mx-0">
      <BCol md="9" class="revenue-report-wrapper " >
        <div class="mx-4">
          <div class="d-sm-flex justify-content-between align-items-center mb-3">
            <h4 class="card-title mb-50 mb-sm-0">
              Resumen anual
            </h4>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center mr-2">
                <span class="bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer" />
                <span>Ingresos</span>
              </div>
              <div class="d-flex align-items-center ml-75">
                <span class="bullet bullet-warning svg-font-small-3 mr-50 cursor-pointer" />
                <span>Gastos</span>
              </div>
            </div>
          </div>
          <vue-apex-charts id="revenue-report-chart" type="bar" height="230" :options="revenueReport.chartOptions" :series="data.report"  />
        </div>
      </BCol>

      <BCol
        md="3"
        class="budget-wrapper m-auto"
      >

      <b-dropdown
        :text="selectedYear"
        v-model="selectedYear"
        size="sm"
        class="budget-dropdown"
        variant="outline-warning"
        >
        
          <b-dropdown-item
            v-for="year in years"
            :key="year"
            :value="year"
            @click="selectedYear=year"
          >
            {{ year }}
          </b-dropdown-item>
        </b-dropdown>
        <h2 class="font-weight-bold">{{ formatCurrency(data.total_incomes + data.total_expenses ) }}</h2>
        
        <div class="d-flex justify-content-center mt-2">
          <span class="font-weight-bolder mr-25">Ingresos:</span>
          <span>{{ formatCurrency(data.total_incomes) }}</span>
        </div>
        <div class="d-flex justify-content-center ">
          <span class="font-weight-bolder mr-25">Gastos:</span>
          <span>{{ formatCurrency(data.total_expenses) }}</span>
        </div>
        

        <BButton class="mt-2" :to="{ name: 'invoices-add'}" v-ripple.400="'rgba(255, 255, 255, 0.15)'" style="background-color: #ff9f43; color:white;" variant="none">
          Añadir factura
        </BButton>
      </BCol>
    </BRow>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'
import currency from '@/utils/currency'
import { inject, watch} from '@vue/composition-api'

export default {
  components: {
    VueApexCharts,
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      revenue_report: {},
      years: [
        "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030", "2031", 
        "2032", "2033"
      ],
      revenueReport: {
        chartOptions: {
          chart: {
            stacked: true,
            type: 'bar',
            toolbar: { show: false },
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
            },
            yaxis: {
              lines: { show: false },
            },
          },
          xaxis: {
            categories: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            labels: {
              style: {
                colors: '#6E6B7B',
                fontSize: '17px',
                fontFamily: 'Montserrat, Helvetica, Arial, serif',
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.primary, $themeColors.warning],
          // $themeColors.info,
          plotOptions: {
            bar: {
              columnWidth: '20%',
              endingShape: 'rounded',
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              style: {
                colors: '#6E6B7B',
                fontSize: '17px',
                fontFamily: 'Montserrat, Helvetica, Arial, serif',
              },
            },
          },
        },
      },
      // budget chart
      budgetChart: {
        options: {
          chart: {
            height: 80,
            toolbar: { show: false },
            zoom: { enabled: false },
            type: 'line',
            sparkline: { enabled: true },
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 5],
            width: [2],
          },
          colors: ['#666666', '#dcdae3'],
          tooltip: {
            enabled: false,
          },
        },
      },
    }
  },
  emits: ['refetch-revenues'],
  setup(props, {emit}) {
    const {formatCurrency}=currency()
    const selectedYear = inject("selectedYear")

    watch(selectedYear, () => {
      emit('refetch-revenues')
    })
    return {
      formatCurrency,
      selectedYear
    }
  }
}
</script>
